import { useEffect, memo } from 'react';
import { useMakeSelect } from '@dbh/reselect-extra';
import { makeSelectIsUserSignedIn } from '@dbh/user-area-redux';
import { u as useLoadGoogleOneTapSignInApi } from './useLoadGoogleOneTapSignInApi-d19660c5.js';
import 'jwt-decode';
import '@dbh/with-conforms-to-for-production-www';
import 'lodash/isPlainObject';
import 'lodash/noop';
import '@dbh/create-custom-react-prop-type';
import '@dbh/create-use-bound-event-creator';
import 'prop-types';

/**
 * Asynchronously loads the `Google one tap` `API` and display the one tap prompt.
 * Note: make sure you are using `dev.daybreakhotels.xyz` while working on
 * "Google one tap".
 * `dev.daybreakhotels.xyz` has been added to be able to use `Google One Tap`
 * while developing, and avoid the unknown origin
 * error. Unfortunately the `Google` dashboard doesn’t accept domains that
 * end in `.localhost`.
 * @see {@link https://developers.google.com/identity/one-tap/web/get-started#load_the_javascript_client_library}
 */const useLoadGoogleOneTapSignInApiAndGetCredential=()=>{const a=useLoadGoogleOneTapSignInApi(),b=useMakeSelect(makeSelectIsUserSignedIn);useEffect(()=>{b||a(()=>{window.google.accounts.id.prompt();});},[b,a]);};var useLoadGoogleOneTapSignInApiAndGetCredential$1 = useLoadGoogleOneTapSignInApiAndGetCredential;

const OneTapSignIn=/*#__PURE__*/memo(()=>(useLoadGoogleOneTapSignInApiAndGetCredential$1(),null));OneTapSignIn.displayName="OneTapSignIn";

export { OneTapSignIn as default };
